import { ButtonCustom, ButtonStyle } from './styles'
interface ButtonProps extends ButtonStyle {
  text: string
  onClick?: any
  color?: string
  type?: any
  disabled?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  minWidth?: string
  width?: string
}

export const ButtonPagination = ({
  text,
  onClick,
  disabled,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  variantButton = 'default',
  backgroundColor = null,
  textColor = null,
  borderColor = null,
  type = 'button',
  width,
  minWidth,
  hide = false,
  boxShadow,
  startIcon,
  endIcon
}: ButtonProps) => (
  <ButtonCustom
    startIcon={startIcon}
    endIcon={endIcon}
    minWidth={minWidth}
    onClick={onClick}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    variantButton={variantButton}
    backgroundColor={backgroundColor}
    textColor={textColor}
    borderColor={borderColor}
    type={type}
    width={width}
    hide={hide}
    boxShadow={boxShadow}
    disabled={disabled}
  >
    {text}
  </ButtonCustom>
)
